import { IPermissionSettings } from "@utils/permissionUtils";
import React from "react";
import { RouteProps } from "react-router-dom";

import { AppContext, ContextEvents, IAppContext } from "../contexts/appContext/AppContext.types";
import PrivateRoute from "./PrivateRoute";

interface IProps extends RouteProps, IPermissionSettings {}

/** Re-renders content on company change */
class CompanyDependentPrivateRoute extends React.PureComponent<IProps> {
    static contextType = AppContext;

    constructor(props: IProps, context: IAppContext) {
        super(props, context);

        context.eventEmitter.on(ContextEvents.CompanyChanged, this.companyChange);
    }

    companyChange = (): void => {
        this.forceUpdate();
    };

    componentWillUnmount(): void {
        this.context.eventEmitter.off(ContextEvents.CompanyChanged, this.companyChange);
    }

    render() {
        return <PrivateRoute  {...this.props} key={this.context.getCompany().Id}/>;
    }
}

export default CompanyDependentPrivateRoute;